export const reviewsSummaryQuery = `query ReviewsSummary ($country: String) {
  local: _allCustomerReviewsMeta(filter: {country: {eq: $country }}) {
    count
  }
  global: _allCustomerReviewsMeta {
    count
  }
  aggregated: reviewAggregation {
    count
    recommendRate
    averageStars
  }
}`

export const reviewsListingQuery = `query ReviewsListing (
    $limit: IntType!,
    $skip: IntType!,
    $filter: CustomerReviewModelFilter,
    $globalFilter: CustomerReviewModelFilter
  ) {
  local: _allCustomerReviewsMeta(filter: $filter) {
    count
  }
  global: _allCustomerReviewsMeta(filter: $globalFilter) {
    count
  }
  aggregated: reviewAggregation {
    count
    recommendRate
    averageStars
  }
  reviews: allCustomerReviews(first: $limit, skip: $skip, filter: $filter, orderBy: submittedAt_DESC) {
    id
    submittedAt
    body
    title
    reply
    displayName
    anonymous
    skus
    country
    recommend
    rating
  }
}`

export const reviewProductItemIdsQuery = `query ReviewProductItemIds ($skus: [String]) {
  products: allBaseProducts(filter: {sku: {in: $skus}}) {
    id
  }
}`

export const productReviewAggregationsQuery = `query ProductReviewAggregations ($products: [ItemId]) {
  aggregations: allProductReviewAggregations(filter: {product: {in: $products}}) {
    recommendRate
    averageStars
    count
  }
  genericAggregation: reviewAggregation {
    count
    recommendRate
    averageStars
  }
}`